export const devicesListTimeOut = 10000;
export const ruleEntitiesListTimeOut = 10000;
export const notificationCountTimeOut = 10000;
export const shipMapTimeOut = 10000;
export const systemHealthTimeOut = 10000;
export const lastNotificationsTimeOut = 10000;
export const newNotificationsTimeOut = 5000;
export const onBoardDevicesTimeOut = 10000;
export const temperatureTimeOut = 10000;
